// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".contact__title[data-v-5a5f2b43]{margin-bottom:18px}.contact__phone[data-v-5a5f2b43]{max-width:50%}.contact__button_mobile[data-v-5a5f2b43]{display:none}@media (max-width:900px){.contact__title[data-v-5a5f2b43]{display:none}.contact__phone[data-v-5a5f2b43]{max-width:none}.contact__button[data-v-5a5f2b43]{display:none}.contact__button_mobile[data-v-5a5f2b43]{position:fixed;bottom:0;display:block;width:100%;margin:0 -10px}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
